import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('unitSelectPanelField');

    return {
        ALL_UNITS: t('allUnits'),
        NO_UNITS_FOUND: t('noUnitsFound'),
        SEARCH: t('search')
    };
};

export default useTranslation;
